export const INTERVIEW_RECORDING_INTERACTION_KEY = 'interview.recording';

export interface InterviewRecordingInteractionState {
  currentTimeSeconds: number;
  durationSeconds: number;
  isPlaying: boolean;
  autoScrollTranscript: boolean;
  seekRequest?: {
    id: number;
    timeSeconds: number;
    playAfterSeek?: boolean;
  };
}
